export default "__VITE_ASSET__5a54573c__"